import * as React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

interface DireccionJson {
    NombreCompleto?: string | null;
    Nombre?: string | null;
    Apellido1?: string | null;
    Apellido2?: string | null;
    Empresa?: string | null;
    Nif?: string | null;
    Direccion?: string | null;
    Numero?: string | null;
    Portal?: string | null;
    Escalera?: string | null;
    Piso?: string | null;
    Poblacion?: string | null;
    Provincia?: string | null;
    CodigoPostal?: string | null;
    Telefono?: string | null;
    Observaciones?: string | null;
}

interface VisualizadorDireccionProps {
    direccion: string | null;
    label: string;
}

function Campo({ label, value }: { label: string; value: string | null | undefined }) {
    if (!value) return null;
    return (
        <FormGroup className="mb-1">
            <Label className="mb-0 small">{label}</Label>
            <Input readOnly bsSize="sm" value={value} />
        </FormGroup>
    );
}

function parsearDireccionJson(texto: string): DireccionJson | null {
    try {
        const parsed = JSON.parse(texto);
        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
            return parsed as DireccionJson;
        }
    } catch {
        // no es JSON
    }
    return null;
}

export function VisualizadorDireccion({ direccion, label }: VisualizadorDireccionProps) {
    if (!direccion) {
        return (
            <FormGroup>
                <Label>{label}</Label>
                <Input readOnly type="textarea" rows={3} value="N/A" />
            </FormGroup>
        );
    }

    const json = parsearDireccionJson(direccion);

    if (!json) {
        return (
            <FormGroup>
                <Label>{label}</Label>
                <Input readOnly type="textarea" rows={5} value={direccion} />
            </FormGroup>
        );
    }

    const nombre = json.NombreCompleto
        || [json.Nombre, json.Apellido1, json.Apellido2].filter(Boolean).join(" ") || null;

    const calle = [json.Direccion?.trim(), json.Numero].filter(Boolean).join(" nº ") || null;

    const detalle = [
        json.Portal ? `Portal ${json.Portal}` : null,
        json.Escalera ? `Esc. ${json.Escalera}` : null,
        json.Piso ? `Piso ${json.Piso}` : null,
    ].filter(Boolean).join(" · ") || null;

    const empresa = [json.Empresa, json.Nif].filter(Boolean).join(" · ") || null;

    return (
        <div>
            <Label>{label}</Label>
            <div className="border rounded p-2">
                <Campo label="Nombre" value={nombre} />
                <Campo label="Empresa / NIF" value={empresa} />
                <Campo label="Calle" value={calle} />
                <Campo label="Detalle" value={detalle} />
                <Row>
                    <Col xs={7}>
                        <Campo label="Población" value={[json.CodigoPostal, json.Poblacion].filter(Boolean).join(" ") || null} />
                    </Col>
                    <Col xs={5}>
                        <Campo label="Provincia" value={json.Provincia || null} />
                    </Col>
                </Row>
                <Campo label="Teléfono" value={json.Telefono || null} />
                <Campo label="Observaciones" value={json.Observaciones || null} />
            </div>
        </div>
    );
}
